<div class="container">
  <mat-table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 download-table" matSortActive="upload_date"
             matSortDirection="desc">

    <!-- File Name Column -->
    <ng-container matColumnDef="file_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_name"> File Name</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-file_name"> {{element.file_name}} </mat-cell>
    </ng-container>

    <!-- File Size Column -->
    <ng-container matColumnDef="file_size">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_size"> Size</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-file_size"> {{element.file_size | filesize}} </mat-cell>
    </ng-container>


    <!-- Owner Email Column -->
    <ng-container matColumnDef="owner_email">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-owner_email"> Owner</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-owner_email">
        {{element.owner_email}}
      </mat-cell>
    </ng-container>

    <!-- Upload Date Column -->
    <ng-container matColumnDef="upload_date">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-upload_date"> Upload Date</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-upload_date">
        <ng-container *ngIf="element.upload_date != 'None'">
          {{element.upload_date | date : 'mediumDate'}}
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Deletion Date Column -->
    <ng-container matColumnDef="deletion_date">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-deletion_date"> Deletion Date</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-deletion_date">
        <ng-container *ngIf="element.deletion_date != 'None'">
          {{element.deletion_date | date : 'mediumDate'}}
        </ng-container>
      </mat-cell>
    </ng-container>
    <!-- Malware Scan Status Column -->
    <ng-container matColumnDef="malware_scan_status">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-malware_scan_status" 
        matTooltip="All files are automatically scanned for viruses and malicious content before download. You can only download files that have passed the security check.">
        Scan
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-malware_scan_status">
        <ng-container *ngIf="element.malware_scan_status === 'IN_PROGRESS'">
          <mat-icon class="status-icon slow-rotate" matTooltip="Scan in progress. The larger the file, the longer the scan may take." style="color: #1976d2;">autorenew</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'OK'">
          <mat-icon class="status-icon success-icon" matTooltip="No threats detected" style="color: green;">verified_user</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'THREAT'">
          <mat-icon class="status-icon error-icon" matTooltip="Threat detected" style="color: red;">warning</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'ERROR'">
          <mat-icon class="status-icon error-icon" matTooltip="Scan error" style="color: red;">error</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'SCAN_SKIPPED'">
          <mat-icon class="status-icon warning-icon" matTooltip="File scan unavailable (unsupported format). Please verify file safety before downloading." style="color: orange;">info</mat-icon>
        </ng-container>
        <ng-container *ngIf="!element.malware_scan_status || (element.malware_scan_status !== 'IN_PROGRESS' && element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'THREAT' && element.malware_scan_status !== 'ERROR' && element.malware_scan_status !== 'SCAN_SKIPPED')"></ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <mat-header-cell *matHeaderCellDef class="mat-column-buttons"></mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-buttons cell-align-right">
        <button class="vlr-outline-btn vlr-icon-btn"
                matTooltip="Download this file"
                (click)="download(element.object_key, element.file_name)"
                [disabled]="element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'SCAN_SKIPPED'">
          <mat-icon fontSet="material-icons-outlined">file_download</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>


  <div class="d-flex justify-content-center">
    <div class="spinner-border m-4" role="status" *ngIf="flag_loader">
    </div>
    <div class="m-4" *ngIf="dataSource.data.length === 0 && !flag_loader">
      No data to show
    </div>
  </div>
</div>
